import React from 'react';

import classNames from 'classnames';

import { Link, LinkIntent, LinkIconPosition, LinkType } from '../Link/Link';
import styles from './BackArrowLink.module.css';

export type Props = {
  className?: string;
  isExternal?: boolean;

  linkIntent?: LinkIntent;

  onClick?: () => void;
  redirect?: string;
  title: JSX.Element | string;
};

export const BackArrowLink = React.memo((props: Props) => {
  const {
    className,
    linkIntent,

    title,

    onClick,
    redirect,
    isExternal = false,
  } = props;

  const linkProps = {
    className: classNames(styles.backArrowLink, className),
    onClick,
    iconPosition: LinkIconPosition.Left,
    intent: linkIntent ?? LinkIntent.tertiary,
  };

  return redirect ? (
    isExternal
      ? <Link
        type={LinkType.ExternalHref}
        to={redirect}
        {...linkProps}
      >
        {title}
      </Link>

      : <Link
        type={LinkType.Href}
        to={redirect}
        {...linkProps}
      >
        {title}
      </Link>
  ) : (
    <Link
      type={LinkType.Span}
      {...linkProps}
    >
      {title}
    </Link>
  );
});

BackArrowLink.displayName = 'BackArrowLink';
